/**
 * Numerator reads before Denominator throughout the tool: the count comes first,
 * then what it was counted against. The API returns its columns in alphabetical
 * order, which puts them the other way round, so any column list built from a
 * response is put through this before it is drawn or exported.
 *
 * Everything else keeps the order it arrived in, and a list holding only one of
 * the two, or neither, comes back unchanged.
 */
export function orderNumeratorFirst(headers: Array<string>): Array<string> {
  if (!headers) {
    return headers;
  }
  const denominator = headers.indexOf('Denominator');
  const numerator = headers.indexOf('Numerator');
  if (denominator < 0 || numerator < 0 || numerator < denominator) {
    return headers;
  }
  const ordered = headers.filter(header => header !== 'Numerator');
  ordered.splice(ordered.indexOf('Denominator'), 0, 'Numerator');
  return ordered;
}
